// removed by extract-text-webpack-plugin
module.exports = {"bouncedelay":"legacy-bouncedelay","loopOpacity":"legacy-loopOpacity","rotate":"legacy-rotate","slowBounce":"legacy-slowBounce","moveRight":"legacy-moveRight","moveLeft":"legacy-moveLeft"};


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/theme/legacy.less
// module id = 118
// module chunks = 0